export enum ActorIdType {
  userId = 'userId',
  serviceAccount = 'serviceAccount',
}

export type ActorIdTypeType = keyof typeof ActorIdType;
